module.exports = __webpack_public_path__ + "static/media/DSC_0119-2.77a87e95.jpg";